import { render, staticRenderFns } from "./HiddenInput.vue?vue&type=template&id=4dd7f56a&"
import script from "./HiddenInput.vue?vue&type=script&lang=js&"
export * from "./HiddenInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dd7f56a')) {
      api.createRecord('4dd7f56a', component.options)
    } else {
      api.reload('4dd7f56a', component.options)
    }
    module.hot.accept("./HiddenInput.vue?vue&type=template&id=4dd7f56a&", function () {
      api.rerender('4dd7f56a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-types/inputs/HiddenInput.vue"
export default component.exports